import * as t from "io-ts";
import { createOutgoingInvoiceTypes } from "dora-contracts";

const { failedOutgoingInvoiceT, failedOutgoingInvoicesT } =
  createOutgoingInvoiceTypes({ decimal: t.string });

export const invoiceT = failedOutgoingInvoiceT;
export const invoicesT = failedOutgoingInvoicesT;
export type Invoice = t.TypeOf<typeof invoiceT>;
